import React, { Fragment } from 'react';
import i18n from 'i18next';
import './PersonaContent.scss';
import { personaToProp, personaToBefore } from './PersonaContentImageMap';
import { ColourTheme } from '../../../../types/ColourTheme';
import { convertNumericKeysToArray } from '../../../../newHelpers/convertNumericKeysToArray';
import { stylize } from '../../../../newHelpers/stylize';
import { StoreContext } from '../../../../store/StoreContext';

type Props = {
  theme: ColourTheme;
};

export const PersonaContent = (props: Props) => {
  const interviewCopy: Copy = convertNumericKeysToArray(i18n.t(`${props.theme}Landing.interview`, { returnObjects: true }));
  const transformationCopy: Copy = convertNumericKeysToArray(i18n.t(`${props.theme}Landing.transformation`, { returnObjects: true }));
  const cancerCopy: Copy = convertNumericKeysToArray(i18n.t(`${props.theme}Landing.cancer`, { returnObjects: true }));
  return (
    <div className={`PersonaContent ${props.theme}`}>
      <div className="section-1">
        <div className="left-container">
          <h2>{interviewCopy.title}</h2>
          {interviewCopy.p.map((item, index) =>
            <p key={index}>{stylize(item)}</p>
          )}
        </div>
        <div className="right-container">
          <div>
            <img src={personaToProp[props.theme]} alt="scale-img" />
          </div>
        </div>
      </div>
      {(props.theme === ColourTheme.pomegranate || props.theme === ColourTheme.orchidpink || props.theme === ColourTheme.carrot || props.theme === ColourTheme.sunflower) &&
        <StoreContext.Consumer>
          {
            store =>
              <div className={`pomegranate-quote ${store.currentLanguage}`}>
                <div className={`bg ${props.theme}`} />
                <h2 className={props.theme}>{i18n.t(`${props.theme}Landing.quote.p`)}</h2>
              </div>
          }
        </StoreContext.Consumer>
      }
      <div className="section-2">
        <div className="left-container">
          <div>
            <img src={personaToBefore[props.theme]} alt="scale-img" />
          </div>
        </div>
        <div className="right-container">
          <h2>{transformationCopy.title}</h2>
          {transformationCopy.p.map((item, index) =>
            <p key={index}>{item}</p>
          )}
          {props.theme === ColourTheme.pomegranate &&
            <Fragment>
              <h2>{cancerCopy.title}</h2>
              {cancerCopy.p.map((item, index) =>
                <p key={index}>{item}</p>
              )}
            </Fragment>
          }
        </div>
      </div>
    </div>
  );
};

type Copy = {
  title: string;
  p: string[];
};
